import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { Conversation } from '../types';

export const getConversationRecencyTimestamp = (
	conversation: Pick<Conversation, 'lastMessageTimestamp' | 'timeCreated'>,
): string | undefined =>
	conversation.lastMessageTimestamp ??
	(fg('rovo-chat-ai-inbox') ? conversation.timeCreated : undefined);
